export const API = {
  REGISTER: "/auth/register",
  LOGIN: "/auth/login",
  VERIFY: "/auth/verify",
  RESEND_VERIFICATION: "/auth/resend-verification",
  DEPLOY_USER_TENANT: "/tenants/deploy/user/:userId",
  UNDEPLOY_USER_TENANT: "/tenants/undeploy/user/:userId",
  GET_TENANT: "/tenants/user/:userId",
  FORGOT_PASSWORD: "/auth/forgot-password",
  VERIFY_RESET_TOKEN: "/auth/verify-reset-token",
  RESET_PASSWORD: "/auth/reset-password",
  CONTACT_FORM: "/contact/submit",
  TERMS_AND_CONDITIONS: "/legal-documents/type/TERMS_AND_CONDITIONS/latest",
  PRIVACY_POLICY: "/legal-documents/type/PRIVACY_POLICY/latest",
};
